"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseSelectionBehaviour_1 = require("./BaseSelectionBehaviour");
var browserInfo_1 = require("./browserInfo");
var browserInfo_2 = require("./browserInfo");
var BaseSelectionBehaviour_2 = require("./BaseSelectionBehaviour");
var BaseSelectionBehaviour_3 = require("./BaseSelectionBehaviour");
var ExplorerStyle = (function (_super) {
    __extends(ExplorerStyle, _super);
    function ExplorerStyle(deleteHandler) {
        var _this = _super.call(this) || this;
        _this._deleteHandler = deleteHandler;
        return _this;
    }
    ExplorerStyle.prototype.mouseClicked = function (event) {
        var row = this.getRow(event);
        if (row === undefined) {
            this.clearSelection();
            return;
        }
        if (row !== undefined && (event.mask === BaseSelectionBehaviour_3.MOUSEBUTTONS.LEFT || event.mask === BaseSelectionBehaviour_3.MOUSEBUTTONS.RIGHT)) {
            if (this.isShiftClicked) {
                var min = Math.min(row, this.activeRow);
                var max = Math.max(row, this.activeRow);
                this.clearSelection();
                for (var i = min; i <= max; i++) {
                    this.addSelectedRow(i);
                }
                return;
            }
            if (!this.ctrlOrMacOsAndCmdClicked()) {
                this.clearSelection();
            }
            this.triggerRow(row);
            this.activeRow = row;
        }
    };
    ExplorerStyle.prototype.keyPressed = function (event) {
        _super.prototype.keyPressed.call(this, event);
        switch (event.code) {
            case BaseSelectionBehaviour_1.KEYS.ESCAPE:
                this.clearAllSelectedRows();
                break;
            case BaseSelectionBehaviour_1.KEYS.UP:
                this.moveSelectedRow(this.getLatestRow(), -1, this.isShiftClicked);
                break;
            case BaseSelectionBehaviour_1.KEYS.DOWN:
                this.moveSelectedRow(this.getLatestRow(), 1, this.isShiftClicked);
                break;
            case BaseSelectionBehaviour_1.KEYS.a:
                if (this.ctrlOrMacOsAndCmdClicked()) {
                    for (var i = 0; i < this.getNumberOfRows(); i++) {
                        this.addSelectedRow(i);
                    }
                }
                break;
            case BaseSelectionBehaviour_1.KEYS.DEL:
            case BaseSelectionBehaviour_1.KEYS.ENTF:
                if (this._deleteHandler) {
                    this._deleteHandler(this.getSelectedRows());
                }
                break;
            default:
        }
    };
    ExplorerStyle.prototype.ctrlOrMacOsAndCmdClicked = function () {
        return (this.isCtrlClicked || (browserInfo_1.BrowserInfo.getOS() === browserInfo_2.OPERATING_SYSTEMS.OSX && this.isCmdClicked));
    };
    ExplorerStyle.prototype.keyReleased = function (event) {
        _super.prototype.keyPressed.call(this, event);
    };
    return ExplorerStyle;
}(BaseSelectionBehaviour_2.BaseSelectionBehaviour));
exports.ExplorerStyle = ExplorerStyle;
//# sourceMappingURL=explorerStyle.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/grids/selectBehaviours/explorerStyle.js
// module id = 75
// module chunks = 0